module.exports = __webpack_public_path__ + "img/rvn.da1db9d2.svg";